class TavKlarnaSimulator extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const dialog = this.querySelector('dialog');
    const openButton = this.querySelector('[data-klarna-open]');
    openButton.addEventListener('click', () => dialog.showModal(), options);
    this.querySelector('[data-klarna-close]').addEventListener('click', () => dialog.close(), options);
    dialog.addEventListener('close', () => openButton.focus({ preventScroll: true }), options);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    }, options);
    this.amount = Math.max(0, Number(this.dataset.amount) || 0);
    this.plan = this.querySelector('[data-klarna-plan]:checked')?.value || 'three';
    this.labels = JSON.parse(this.querySelector('[data-klarna-labels]').textContent);
    this.money = new Intl.NumberFormat(this.dataset.locale || 'fr-FR', { style: 'currency', currency: this.dataset.currency || 'EUR' });
    this.scope = this.closest('.shopify-section') || document;
    const group = `tav-klarna-${crypto.randomUUID()}`;
    this.querySelectorAll('[data-klarna-plan]').forEach(input => { input.name = group; });
    this.addEventListener('change', event => {
      if (!event.target.matches('[data-klarna-plan]')) return;
      this.plan = event.target.value;
      this.render();
    }, options);
    if (this.dataset.context === 'product') {
      this.scope.addEventListener('form:updated', event => {
        if (!event.target.matches('product-form') || !event.target.querySelector('form[action$="/cart/add"]')) return;
        this.refreshProductAmount();
      }, options);
      this.scope.addEventListener('variant:selected', () => { this.setAttribute('aria-busy', 'true'); }, options);
      this.scope.addEventListener('variant:updated', event => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        this.removeAttribute('aria-busy');
        if (!event.detail?.resource) { this.hidden = true; return; }
        this.refreshProductAmount();
      }, options);
      this.scope.addEventListener('change', event => {
        if (event.target.name === 'quantity') this.refreshProductAmount();
      }, options);
      this.scope.addEventListener('input', event => {
        if (event.target.name === 'quantity') this.refreshProductAmount();
      }, options);
      document.addEventListener('DOMContentLoaded', () => this.refreshProductAmount(), { ...options, once: true });
      this.refreshProductAmount();
    } else {
      document.addEventListener('cart:updated', event => { this.setAmount(event.detail?.resource?.total_price); }, options);
    }
    this.render();
  }
  disconnectedCallback() {
    this.controller?.abort();
  }
  refreshProductAmount() {
    const form = this.scope.querySelector('product-form');
    if (!form) return;
    const quantityBreaks = form.querySelector('[data-ref="quantity-breaks"]');
    if ((quantityBreaks?.isActive?.() || form.querySelector('[data-chevet-discount="5"]')) && typeof form.getCurrentTotalPrice === 'function') {
      this.setAmount(form.getCurrentTotalPrice().price);
      return;
    }
    const priceNode = form.querySelector('[data-ref="add-to-cart-button-container"]');
    const unitPrice = Number(priceNode?.dataset.price);
    const quantity = Math.max(1, parseInt(form.querySelector('input[name="quantity"]')?.value, 10) || 1);
    if (Number.isFinite(unitPrice)) this.setAmount(unitPrice * quantity);
  }
  setAmount(amount) {
    if (!Number.isFinite(Number(amount))) return;
    this.amount = Math.max(0, Math.round(Number(amount)));
    this.removeAttribute('aria-busy');
    this.render();
  }
  render() {
    this.hidden = this.amount <= 0;
    this.querySelector('[data-klarna-total]').textContent = this.money.format(this.amount / 100);
    this.querySelector('[data-klarna-summary]').textContent = this.labels[this.plan];
    const base = Math.floor(this.amount / 3);
    const remainder = this.amount % 3;
    const amounts = this.plan === 'later' ? [0, this.amount] : [base + (remainder > 0 ? 1 : 0), base + (remainder > 1 ? 1 : 0), base];
    const preview = this.plan === 'later' ? this.labels.previewLater : remainder === 0 ? this.labels.previewSame : this.labels.previewVaries;
    this.querySelector('[data-klarna-preview]').textContent = preview.replace('__amount__', this.money.format((this.plan === 'later' ? this.amount : base) / 100));
    const dates = [this.labels.today, this.labels.day30, this.labels.day60];
    const list = this.querySelector('[data-klarna-schedule]');
    list.classList.toggle('is-later', this.plan === 'later');
    list.replaceChildren(...amounts.map((amount, index) => {
      const item = document.createElement('li');
      const date = document.createElement('small');
      date.textContent = dates[index];
      const value = document.createElement('strong');
      value.textContent = this.money.format(amount / 100);
      item.append(date, value);
      return item;
    }));
  }
}
if (!customElements.get('tav-klarna-simulator')) customElements.define('tav-klarna-simulator', TavKlarnaSimulator);

